<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="700px"
  >
    <template v-slot:activator="{ on:dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn 
            style="width:36px; height:36px; !important"
            icon
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon color="hrissecondary">
              mdi-plus-circle
            </v-icon>
          </v-btn>
        </template>
        <span>New request</span>
      </v-tooltip>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="hrissecondary"
      :title="cardTitle"
      text="Request new claim"
      class="mb-0"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row v-if="isClaimOnBehalf">
            <v-col cols="12">
              <v-fade-transition>
                <v-icon
                  color="red"
                  class="mb-1 white--text pulse"
                  size="x-large"
                >
                  mdi-alert-circle
                </v-icon>
              </v-fade-transition>
              <span 
                class="ml-1 red--text font-16"
              >
                Kindly note that you are apply claim on behalf of <span class="black--text">{{ employee.person.name }}</span>
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="claimCycleId"
                v-validate="'required'"
                :error-messages="errors.collect('claim_cycle_id')"
                :items="formattedClaimCycles"
                data-vv-name="claim_cycle_id"
                data-vv-as="claim cycle"
                item-text="label"
                item-disabled="disable"
                item-value="id"
                label="Claim Cycle"
                outlined
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="closeDialog"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          :disabled="loading"
          color="hrissecondary"
          class="px-10 white--text"        
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employee: {
        type: Object,
        required: true,
      },
      claimCycles: {
        type: Array,
        required: true,
      },
      isClaimOnBehalf: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        loading: false,
        progressing: false,
        claimCycleId: null,
      }
    },
    computed: {
      formattedClaimCycles () {
        return this.claimCycles.map(cycle => ({
          id: cycle.id,
          label: `${cycle.start_date} - ${cycle.end_date}${cycle.disable ? ' (Draft)' : ''}`,
          disable: cycle.disable,
        }))
      },
      cardTitle () {
        if (this.isClaimOnBehalf && this.employee.person) {
          return `New Claim (${this.employee.person.name})`
        }
        return 'New Claim'
      },
    },
    methods: {
      closeDialog () {
        this.claimCycleId = null
        this.dialog = false
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            this.$api.claimRequests().create(this.employee.employee_uid, this.claimCycleId, { isClaimOnBehalf: this.isClaimOnBehalf })
              .then(res => {
                if (res.status === 201) {
                  this.progressing = false
                  this.$emit('created')                
                  this.$snack({ message: res.data.status })

                  this.closeDialog()             
                }
              })
              .catch(error => {
                if (error.response.status === 405 || error.response.status === 500) {
                  this.$snack({ 
                    color: 'error',
                    message: error.response.data.status, 
                  })

                  this.progressing = false
                }
              })
          })
      },
    },
  }
</script>

<style lang="css" scoped>
.card-overflow {
  height: 40vh;
  overflow-y: scroll;
}
::-webkit-scrollbar {
  width: 0px;  /* Remove scrollbar space */
  background: transparent;  /* Optional: just make scrollbar invisible */
}
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
.pulse {
  animation: pulse 1.2s infinite;
}
@keyframes pulse {
  0% { opacity: 1; transform: scale(0.8); }
  16% { opacity: 1; transform: scale(0.6); }
  32% { opacity: 1; transform: scale(0.4); }
  48% { opacity: 1; transform: scale(0.6); }
  75% { opacity: 1; transform: scale(0.8); }
  100% { opacity: 1; transform: scale(1); }
}
</style>
